import React, { useState,useEffect } from "react";
import BoldIcon from "../assets/icons/BoldIcon.svg";
import CircleLineIcon from "../assets/icons/circleLineIcon.svg";
import NumberIconLine from "../assets/icons/NumberIcon.svg";
import FlexIcon from "../assets/icons/flexIcon.svg";
import RotateTextIcon from "../assets/icons/rotateTextIcon.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { jobsEndpoint } from '../constants';

function SalaryJob() {
  const navigate = useNavigate();
  const location = useLocation();
  const [jobId, setJobId] = useState(null);
  
  
  // Get job data from previous step (if available)
    // Get job ID from previous step
    useEffect(() => {
      if (location.state?.jobId) {
        setJobId(location.state.jobId);
      } else {
        navigate('/create_jobs');
      }
    }, [location, navigate]);
  // Form state for salary and benefits
  const [formData, setFormData] = useState({
    salaryMin: '',
    salaryMax: '',
    bonusesIncentives: '',
    equityStockOptions: false,
    equityPercentage: '',
    otherBenefits: ''  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  // Validate form
  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.salaryMin.trim()) {
      newErrors.salaryMin = 'Minimum salary is required';
    }
    
    if (!formData.salaryMax.trim()) {
      newErrors.salaryMax = 'Maximum salary is required';
    }
    
    if (formData.salaryMin && formData.salaryMax && 
        parseInt(formData.salaryMin) >= parseInt(formData.salaryMax)) {
      newErrors.salaryMin = 'Minimum salary must be less than maximum salary';
    }
    
    if (!formData.bonusesIncentives.trim()) {
      newErrors.bonusesIncentives = 'Bonuses & Incentives description is required';
    }
    
    if (!formData.otherBenefits.trim()) {
      newErrors.otherBenefits = 'Other Benefits description is required';
    }

    if (formData.equityStockOptions && !formData.equityPercentage.trim()) {
      newErrors.equityPercentage = 'Equity percentage is required when equity option is selected';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const token = localStorage.getItem('token');
      
      // Prepare the complete job data
      const jobData = {
        ...formData,
        // Add salary range to offer_price field for consistency
        offer_price: `${formData.salaryMin} - ${formData.salaryMax}`,
        // Combine benefits text
        offer_text: `Bonuses & Incentives: ${formData.bonusesIncentives}\n\nOther Benefits: ${formData.otherBenefits}${formData.equityStockOptions ? `\n\nEquity/Stock Options: ${formData.equityPercentage}%` : ''}`
      };

// Update the fetch call in handleSubmit
const response = await fetch(`${jobsEndpoint}update/step3/${jobId}/`, {
  method: 'PUT',
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Token ${token}`,
  },
  body: JSON.stringify({
    salary_min: formData.salaryMin,
    salary_max: formData.salaryMax,
    bonuses_incentives: formData.bonusesIncentives,
    equity_percentage: formData.equityPercentage,
    other_benefits: formData.otherBenefits,
    offer_text: `Bonuses & Incentives: ${formData.bonusesIncentives}\n\nOther Benefits: ${formData.otherBenefits}`,
    quiet_mode: formData.quietMode
  })
});
// Handle navigation after success
if (response.ok) {
  const result = await response.json();
  navigate("/hiring_job", { state: { jobId } });
}


    } catch (error) {
      console.error('Error updating job:', error);
      setErrors({ submit: 'An error occurred while updating the job' });
    } finally {
      setIsSubmitting(false);
    }
  };

  // Handle back navigation
  const handleBack = () => {
    navigate("/job_description", { state: { jobData: formData } });
  };

  return (
    <div className="w-full inline-flex items-start pb-[8.625rem] pr-[1.875rem] p-0">
      <div className="w-full flex flex-col items-start">
        <div className="main flex flex-col items-start gap-8 self-stretch pt-8 pb-12">
          <div className="flex flex-col items-start gap-6 self-stretch">
            <div className="container flex flex-col items-start self-stretch pb-[32px] pl-[var(--container-padding-desktop, 32px)] pr-[var(--container-padding-desktop, 32px)] pt-0 px-8">
              <div className="page_header flex flex-col items-start self-stretch">
                <div className="content-10 flex flex-wrap items-start content-start self-stretch">
                  <div className="text_and_supporting_text-2 flex flex-col items-start min-w-[20rem]">
                    <div className="self-stretch text-[#181d27] font-semibold">
                      Create Job
                    </div>
                    <div className="self-stretch text-[#535862]">
                      Here is a complete overview of your jobs.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Progress Steps */}
          <div className="flex flex-col items-center justify-center w-full">{/*  */}
            <div className="flex justify-center items-start w-full">
              <div className="_step_base flex flex-col items-center w-60">
                <div className="flex flex-col items-center self-stretch">
                  <div className="self-stretch text-[#009c97] lg:text-base text-sm text-center font-semibold">
                    Define your role
                  </div>
                  <div className="self-stretch text-[#009c97] text-center lg:text-base text-sm">
                  </div>
                </div>
                <div className="_step_icon_base flex justify-center items-center w-6 h-6 rounded-full bg-[#f9f5ff]">
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="#19BFB7" />
                    <circle cx={12} cy={12} r={4} fill="white" />
                  </svg>
                </div>
              </div>
              
              <div className="_step_base-1 flex flex-col items-center w-60">
                <div className="flex flex-col items-center self-stretch">
                  <div className="self-stretch text-[#009c97] text-center font-semibold lg:text-base text-sm">
                    Job Description
                  </div>
                  <div className="self-stretch text-[#009c97] text-center lg:text-base text-sm">
                  </div>
                </div>
                <div className="flex justify-center items-center w-6 h-6 rounded-full bg-[#f9f5ff]">
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="#19BFB7" />
                    <circle cx={12} cy={12} r={4} fill="white" />
                  </svg>
                </div>
              </div>
              
              <div className="_step_base-2 flex flex-col items-center w-60">
                <div className="flex flex-col items-center self-stretch">
                  <div className="self-stretch text-[#009c97] text-center font-semibold lg:text-base text-sm">
                    Salary & Benefits
                  </div>
                  <div className="self-stretch text-[#009c97] text-center lg:text-base text-sm">
                  </div>
                </div>
                <div className="_step_icon_base flex justify-center items-center w-6 h-6 rounded-full bg-[#f9f5ff]">
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="#19BFB7" />
                    <circle cx={12} cy={12} r={4} fill="white" />
                  </svg>
                </div>
              </div>
              
              <div className="_step_base-3 flex flex-col items-center w-60">
                <div className="flex flex-col items-center self-stretch">
                  <div className="self-stretch text-[#414651] text-center font-semibold lg:text-base text-sm">
                    Hiring Preferences
                  </div>
                  <div className="self-stretch text-[#535862] text-center lg:text-base text-sm">
                  </div>
                </div>
                <div className="flex justify-center items-center w-6 h-6 rounded-full bg-neutral-50">
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12Z" stroke="#E9EAEB" strokeWidth="1.5" />
                    <circle cx={12} cy={12} r={4} fill="#D5D7DA" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="flex w-full items-start gap-6 self-stretch">
            <div className="container-1 w-full flex flex-col items-start gap-6 self-stretch pb-[32px] pl-[var(--container-padding-desktop, 32px)] pr-[var(--container-padding-desktop, 32px)] pt-0 px-8">
              <div className="w-full flex md:flex-row flex-col items-start gap-6 self-stretch">
                <div className="flex flex-col items-start gap-1 w-[17.5rem] min-w-[12.5rem] max-w-[17.5rem]">
                  <div className="text_wrapper flex items-center">
                    <div className="text-[#414651] font-semibold leading-6">
                      Salary & Benefits
                 </div>
                    <div className="text-[#009c97] text-sm font-semibold">
                      *
                    </div>
                  </div>
                  <div className="self-stretch text-[#535862] text-sm">
                    Save time—AI generates a complete job description for you!
                  </div>
                </div>

                <div className="frame_1597884787 flex flex-col justify-center items-start gap-6">
                  {/* Salary Range */}
                  <div className="flex flex-col gap-3 w-full">
                    <div className="label_wrapper flex items-start">
                      <div className="text-[#414651] text-sm font-medium">
                        Salary Range
                      </div>
                      <div className="text-[#009c97] text-sm font-medium">
                        *
                      </div>
                    </div>
                    <div className="text-gray-700 flex items-center gap-2 w-full">
                      <input
                        type="number"
                        name="salaryMin"
                        placeholder="Min"
                        value={formData.salaryMin}
                        onChange={handleInputChange}
                        className="bg-white text-gray-700 p-2 rounded-lg outline-none border border-gray-300 w-full"
                      />
                      -
                      <input
                        type="number"
                        name="salaryMax"
                        placeholder="Max"
                        value={formData.salaryMax}
                        onChange={handleInputChange}
                        className="bg-white text-gray-700 p-2 rounded-lg outline-none border border-gray-300 w-full"
                      />
                    </div>
                    {(errors.salaryMin || errors.salaryMax) && (
                      <span className="text-red-500 text-sm">
                        {errors.salaryMin || errors.salaryMax}
                      </span>
                    )}
                  </div>

                  {/* Bonuses & Incentives */}
                  <div className="flex flex-col items-start gap-4 self-stretch">
                    <div className="input_field flex flex-col items-start">
                      <div className="input_with_label-1 flex flex-col items-start self-stretch">
                        <div className="label_wrapper flex items-start">
                          <div className="text-[#414651] text-sm font-medium">
                            Bonuses & Incentives
                          </div>
                          <div className="text-[#009c97] text-sm font-medium">
                            *
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex w-full gap-6 items-center">
                      <div className="input-4 w-56 flex items-start self-stretch rounded-lg border border-[#d5d7da] bg-white">
                        <div className="text-gray-700 content-23 flex items-center py-2 pl-3">
                          <select className="cursor-pointer w-full mr-3 outline-none">
                            <option value="Regular">Regular</option>
                          </select>
                        </div>
                      </div>
                      <div className="flex gap-2 items-center">
                        <span className="cursor-pointer hover:border hover:border-gray-300 hover:rounded-lg">
                          <img src={BoldIcon} alt="Bold" />
                        </span>
                        <span className="cursor-pointer hover:border hover:border-gray-300 hover:rounded-lg">
                          <img src={RotateTextIcon} alt="Rotate Text" />
                        </span>
                        <span className="cursor-pointer hover:border hover:border-gray-300 hover:rounded-lg">
                          <img src={FlexIcon} alt="Flex" />
                        </span>
                        <span className="cursor-pointer hover:border hover:border-gray-300 hover:rounded-lg">
                          <img src={NumberIconLine} alt="Number" />
                        </span>
                        <span className="cursor-pointer hover:border hover:border-gray-300 hover:rounded-lg">
                          <img src={CircleLineIcon} alt="Circle" />
                        </span>
                      </div>
                    </div>
                    <div className="w-full flex flex-col gap-2">
                      <textarea
                        name="bonusesIncentives"
                        value={formData.bonusesIncentives}
                        onChange={handleInputChange}
                        placeholder="Describe the bonuses and incentives..."
                        className="w-full h-38 p-3 rounded-lg border border-gray-300 text-gray-700 bg-white outline-none resize-none"
                      />
                      <p className="text-gray-400 text-sm">
                        <span>{formData.bonusesIncentives.length}</span> characters
                      </p>
                      {errors.bonusesIncentives && (
                        <span className="text-red-500 text-sm">{errors.bonusesIncentives}</span>
                      )}
                    </div>
                  </div>


                  {/* Other Benefits */}
                  <div className="flex flex-col items-start gap-4 self-stretch">
                    <div className="input_field flex flex-col items-start">
                      <div className="input_with_label-1 flex flex-col items-start self-stretch">
                        <div className="label_wrapper flex items-start">
                          <div className="text-[#414651] text-sm font-medium">
                            Other Benefits
                          </div>
                          <div className="text-[#009c97] text-sm font-medium">
                            *
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex w-full gap-6 items-center">
                      <div className="input-4 w-56 flex items-start self-stretch rounded-lg border border-[#d5d7da] bg-white">
                        <div className="text-gray-700 content-23 flex items-center py-2 pl-3">
                          <select className="cursor-pointer w-full mr-3 outline-none">
                            <option value="Regular">Regular</option>
                          </select>
                        </div>
                      </div>
                      <div className="flex gap-2 items-center">
                        <span className="cursor-pointer hover:border hover:border-gray-300 hover:rounded-lg">
                          <img src={BoldIcon} alt="Bold" />
                        </span>
                        <span className="cursor-pointer hover:border hover:border-gray-300 hover:rounded-lg">
                          <img src={RotateTextIcon} alt="Rotate Text" />
                        </span>
                        <span className="cursor-pointer hover:border hover:border-gray-300 hover:rounded-lg">
                          <img src={FlexIcon} alt="Flex" />
                        </span>
                        <span className="cursor-pointer hover:border hover:border-gray-300 hover:rounded-lg">
                          <img src={NumberIconLine} alt="Number" />
                        </span>
                        <span className="cursor-pointer hover:border hover:border-gray-300 hover:rounded-lg">
                          <img src={CircleLineIcon} alt="Circle" />
                        </span>
                      </div>
                    </div>
                    <div className="w-full flex flex-col gap-2">
                      <textarea
                        name="otherBenefits"
                        value={formData.otherBenefits}
                        onChange={handleInputChange}
                        placeholder="Describe other benefits..."
                        className="w-full h-38 p-3 rounded-lg border border-gray-300 text-gray-700 bg-white outline-none resize-none"
                      />
                      <p className="text-gray-400 text-sm">
                        <span>{formData.otherBenefits.length}</span> characters
                      </p>
                      {errors.otherBenefits && (
                        <span className="text-red-500 text-sm">{errors.otherBenefits}</span>
                      )}
                    </div>
                  </div>

                  {/* Error Display */}
                  {errors.submit && (
                    <div className="text-red-500 text-sm">{errors.submit}</div>
                  )}
                </div>
              </div>

              {/* Action Buttons */}
              <div className="actions-1 flex justify-end items-center self-stretch gap-4">
                <button
                  type="button"
                  onClick={handleBack}
                  className="border border-gray-300 rounded-lg text-gray-700 cursor-pointer px-4 py-2"
                >
                  Back
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`rounded-lg text-white cursor-pointer px-4 py-2 ${
                    isSubmitting ? 'bg-gray-400' : 'bg-[#19bfb7] hover:bg-[#16a8a1]'
                  }`}
                >
                  {isSubmitting ? 'Saving...' : 'Next'}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SalaryJob;